import axios from 'axios';
import axiosInstance from '@/shared/api/axios';
import { env } from '@/shared/lib/env';
import type {
  ApiAuthGoogleBody,
  ApiAuthGoogleResponse,
  ApiAuthLogoutBody,
  ApiAuthMePatchBody,
  ApiAuthMeResponse,
} from '@/shared/types/api/auth';

export const apiAuthGooglePost = async (body: ApiAuthGoogleBody): Promise<ApiAuthGoogleResponse> => {
  const { data } = await axios.post<ApiAuthGoogleResponse>(`${env.apiUrl}/auth/google`, body, {
    headers: { 'Content-Type': 'application/json' },
  });
  return data;
};

export const apiAuthLogoutPost = async (body: ApiAuthLogoutBody): Promise<void> => {
  await axiosInstance.post('/auth/logout', body);
};

// Permanently deletes the signed-in user's account. Server returns 204 and
// wipes personal data (name, email, Google link, phone, notifications,
// addresses, support chat); parcel/payment history is kept anonymously.
export const apiAuthAccountDelete = async (): Promise<void> => {
  await axiosInstance.delete('/auth/account');
};

export const apiMeGet = async (): Promise<ApiAuthMeResponse> => {
  const { data } = await axiosInstance.get<ApiAuthMeResponse>('/auth/me');
  return data;
};

export const apiMePatch = async (body: ApiAuthMePatchBody): Promise<ApiAuthMeResponse> => {
  const { data } = await axiosInstance.patch<ApiAuthMeResponse>('/auth/me', body);
  return data;
};

export const apiMeAvatarPost = async (file: File): Promise<ApiAuthMeResponse> => {
  const formData = new FormData();
  formData.append('avatar', file);
  const { data } = await axiosInstance.post<ApiAuthMeResponse>('/auth/me/avatar', formData, {
    headers: { 'Content-Type': 'multipart/form-data' },
  });
  return data;
};
